"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const color = require("color");
const config_1 = require("../../config/config");
const styles = (theme) => (0, styles_1.createStyles)({
    ticketContainer: {
        marginTop: theme.spacing(2)
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        paddingLeft: theme.spacing(1)
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    centerSmall: {
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    ticketTitle: {
        [theme.breakpoints.up('lg')]: {
            textAlign: 'center'
        }
    },
    ticketCard: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(3)
    },
    labelCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center'
    },
    spacing: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },
    pendingPoints: {
        fontWeight: 'bold',
        marginRight: theme.spacing()
    },
    pendingData: {
        marginBottom: theme.spacing(1)
    },
    pendingMessage: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(6)
    },
    textField: {
        '& div input': Object.assign(Object.assign({ textAlign: 'center' }, theme.typography.subtitle1), { letterSpacing: 3 })
    },
    textFieldEntryCode: {
        '& div input': Object.assign(Object.assign({ textAlign: 'center' }, theme.typography.subtitle1), { letterSpacing: 1 })
    },
    button: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(3),
        height: 40,
        alignSelf: 'center',
        [theme.breakpoints.up('sm')]: {
            width: 255
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    playNowButton: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        height: 40,
        alignSelf: 'center',
        [theme.breakpoints.up('sm')]: {
            width: 425
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    skipButton: {
        alignSelf: 'center',
        [theme.breakpoints.up('sm')]: {
            width: 425
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    link: {
        padding: 0
    },
    spacingAround: {
        marginTop: theme.spacing(2)
    },
    verticalPadding: {
        display: 'flex',
        paddingBottom: theme.spacing(3),
        justifyContent: 'center'
    },
    primary: {
        color: theme.palette.primary.main,
        fontWeight: 'bold'
    },
    secondary: {
        color: theme.palette.secondary.main,
        fontWeight: 'bold'
    },
    dialogBackdrop: {
        backgroundColor: color(theme.palette.grey[500]).alpha(0.8).rgb().string()
    },
    dialog: {
        backgroundColor: theme.palette.background.default,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    dialogContent: {
        padding: 0
    },
    dialogContentBlock: {
        display: 'block ',
        textAlign: 'center'
    },
    hideVisualText: {
        position: 'absolute',
        width: '1px',
        height: '1px',
        margin: '-1px',
        padding: '0',
        border: '0',
        clip: 'rect(0, 0, 0, 0)',
        overflow: 'hidden'
    },
    dialogContentPadding: {
        overflowY: 'auto',
        [theme.breakpoints.up('sm')]: {
            maxHeight: '400px'
        },
        [theme.breakpoints.down('sm')]: {
            maxHeight: '600px'
        }
    },
    dialogActions: {
        marginBottom: theme.spacing(3)
    },
    flexDirectionColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center'
    },
    flexDirectionColumn2: {
        flexDirection: 'column',
        textAlign: 'center'
    },
    flexDirectionColumn3: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center'
    },
    iconContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    flexDirectionRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    earningData: {
        marginBottom: theme.spacing(3)
    },
    earningDialogCard: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.grey[300]
    },
    preAssignedDialogCard: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.secondary.main
    },
    earningSummaryDialogCard: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.secondary.main
    },
    secondaryContrast: {
        color: theme.palette.common.white
    },
    secondaryContrastBold: {
        color: theme.palette.common.white,
        fontWeight: 'bold'
    },
    textContrast: {
        color: theme.palette.text.primary
    },
    primaryColor: {
        color: theme.palette.primary.main
    },
    pointsContainer: {
        display: 'flex',
        flexDirection: 'row',
        padding: theme.spacing(3),
        justifyContent: 'space-evenly',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'center'
        }
    },
    helpImageTab: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    disclamierContainer: {
        display: 'flex',
        padding: theme.spacing(2),
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            marginBottom: theme.spacing(2)
        }
    },
    drawNameContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
        }
    },
    disclaimerText: {
        maxWidth: 400,
        minHeight: 40,
        color: theme.palette.common.white
    },
    bonusPointsContainer: {
        display: 'flex',
        flexDirection: 'row',
        padding: theme.spacing(2),
        justifyContent: 'space-evenly',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'center'
        }
    },
    bonusPointsPossible: {
        paddingBottom: theme.spacing(2),
        alignSelf: 'center',
        whiteSpace: 'normal',
        textAlign: 'center'
    },
    bonusPreAssigned: {
        paddingBottom: theme.spacing(1) / 2,
        alignSelf: 'center',
        whiteSpace: 'normal',
        textAlign: 'center'
    },
    secondChance: {
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'center'
        }
    },
    input: {
        textAlign: 'center',
        '&::placeholder': {
            textAlign: 'center',
            color: theme.palette.common.black,
            opacity: 0.6
        }
    },
    inputAdornment: {
        '& p': {
            color: 'rgba(12, 19, 26, 0.7)'
        }
    },
    earningDialogImage: {
        height: 110,
        width: 110,
        marginLeft: '-20%',
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0
        }
    },
    preAssignedDialogImage: {
        height: 110,
        width: 110,
        marginLeft: '-14%',
        alignSelf: 'center',
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0
        }
    },
    earningDialogIcon: {
        fontSize: 100,
        color: theme.palette.primary.main
    },
    pointsEarnedIcon: {
        height: 120,
        width: 150
    },
    earningDialogNotEligibleIcon: {
        fontSize: 100,
        color: theme.palette.action.disabled
    },
    earningDialogActions: {
        marginBottom: theme.spacing(2),
        justifyContent: 'center'
    },
    earningDialogButton: {
        minWidth: 120,
        minHeight: 40
    },
    tabs: {
        marginBottom: theme.spacing(4),
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        '& button:hover, & button:active, & button:focus': {
            color: theme.palette.primary.main,
            [theme.breakpoints.down('xs')]: {
                fontSize: 12
            }
        }
    },
    check: {
        padding: 0
    },
    headingOpacity: {
        color: theme.palette.text.disabled
    },
    icon: {
        fontSize: 50,
        color: theme.palette.primary.main,
        marginRight: 4
    },
    totalEntriesContainer: {
        textAlign: 'center',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    congratulationsText: {
        paddingBottom: theme.spacing(1.5),
        textTransform: 'none'
    },
    ticketCardContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
    },
    wrapText: {
        '@media (max-width: 480px)': {
            whiteSpace: 'break-spaces',
            textAlign: 'center'
        }
    },
    ticketCardContent: {
        flex: 1,
        flexGrow: 1,
        maxWidth: '33%',
        margin: '0 4px',
        padding: '20px',
        backgroundColor: theme.palette.background.default,
        [theme.breakpoints.down('md')]: {
            maxWidth: '48%',
            flex: 'none',
            marginBottom: '10px'
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: '96%',
            flex: 'none',
            marginTop: '10px'
        },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        textAlign: 'center'
    },
    ticketLink: {
        padding: '0 35px',
        textAlign: 'center'
    },
    carouselContainer: {
        '& .slick-dots': {
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'unset',
            height: '25px',
            padding: '0px 16px 30px 16px',
            borderRadius: '5px',
            background: 'rgba(255, 255, 255, 0.8)'
        },
        '& .slick-dots li button': {
            width: '10px',
            height: '10px',
            padding: 0
        },
        '& .slick-dots li button::before': {
            backgroundColor: theme.palette.primary.main
        },
        '& .slick-dots li button:focus::before': {
            border: '2px solid black'
        },
        '& .slick-dots li': {
            width: '10px',
            height: '10px',
            margin: '0 10px'
        },
        '& button.slick-arrow': {
            top: '40%',
            opacity: 1
        },
        '& .slick-next::before, & .slick-prev::before': {
            color: theme.palette.primary.main,
            borderRadius: '50%',
            backgroundColor: 'white',
            border: '5px solid #fff',
            fontSize: '18px',
            boxShadow: '1px 1.5px 4px 0px rgba(170, 174, 181, 0.45)',
            width: '40px',
            height: '40px',
            lineHeight: '32px'
        }
    },
    btnBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '15px 0'
    },
    btnStyle: Object.assign(Object.assign({ justifyContent: 'center', height: '46px', marginRight: '10px', marginLeft: '10px', borderRadius: '90px', border: `2px solid ${theme.palette.primary.main} !important` }, theme.typography.subtitle2), { '@media (min-width: 767px)': {
            minWidth: '250px'
        } }),
    OkBtnStyle: {
        minWidth: config_1.config.internalConfig.V2_CHANGES ? '120px' : '',
        height: config_1.config.internalConfig.V2_CHANGES ? '48px' : ''
    },
    cardMediaStyle: {
        paddingTop: '3%',
        paddingBottom: '3%',
        backgroundSize: 'contain',
        backgroundColor: config_1.config.internalConfig.V2_CHANGES
            ? theme.palette.background.default
            : undefined
    },
    altCardMediaStyle: {
        maxWidth: '360px',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingBottom: theme.spacing(2),
        backgroundSize: 'contain',
        backgroundColor: config_1.config.internalConfig.V2_CHANGES
            ? theme.palette.background.default
            : undefined
    },
    eligibleGameTextStyle: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(1)
    }
});
exports.default = styles;
//# sourceMappingURL=TicketScreenStyle.js.map